import React from 'react'

const Subsection = ({ children, noPadding = false }) => {
  return <div style={{ paddingInlineStart: noPadding ? '0' : '10px' }}>{children}</div>
}

export default Subsection
